const SettingsMenuTypes = (that = {}) => {
    return [
        {
            get enabled() {
                return that.checkPermission("billing.read");
            },
            key: "billing",
            label: that.$t ? that.$t(`billing.billingPlanSettings`) : "Fatura & Ödeme Yönetimi",
            icon: {
                type: "component",
                name: "CreditCard",
            },
            routeMeta: {
                suspendAllow: true,
                shouldSelectAllow: true,
            }
        },
        {
            enabled: true,
            key: "notifications",
            label: that.$t ? that.$t(`settings.notifications`) : "Notifications",
            icon: {
                type: "material-icons",
                name: "notifications",
            },
        },
        {
            get enabled() {
                return that.checkPermission("setting.get");
            },
            key: "features",
            group: that.$t ? that.$t(`message.general`) : "General",
            label: that.$t ? that.$t(`settings.features`) : "Features",
            icon: {
                type: "material-icons",
                name: "settings",
            },
        },
        {
            get enabled() {
                return that.checkPermission("setting.get");
            },
            key: "language",
            group: that.$t ? that.$t(`message.general`) : "General",
            label: that.$t ? that.$t(`settings.languageTimeZone`) : "Language",
            icon: {
                type: "material-icons",
                name: "translate",
            },
        },
        {
            get enabled() {
                return that.checkPermission("setting.get");
            },
            key: "wallet",
            group: that.$t ? that.$t(`message.general`) : "General",
            label: that.$t ? that.$t(`settings.wallet`) : "Wallet",
            icon: {
                type: "material-icons",
                name: "wallet",
            },
        },

        {
            get enabled() {
                return that.checkPermission("setting.get");
            },
            key: "company",
            group: that.$t ? that.$t(`message.company`) : "Company",
            label: that.$t ? that.$t(`settings.companyInformation`) : "Şirket Bilgileri",
            icon: {
                type: "material-icons",
                name: "apartment",
            },
        },
        {
            get enabled() {
                return that?.checkPermission("chat.get");
            },
            key: "company-users",
            group: that.$t ? that.$t(`message.company`) : "Company",
            label: that.$t ? that.$t(`message.users`) : "Users",
            icon: {
                type: "material-icons",
                name: "group",
            },
        },
        {
            get enabled() {
                return that && that.checkPermission(["topic.create", "topic.update", "topic.delete"]);
            },
            key: "departments",
            group: that.$t ? that.$t(`message.company`) : "Company",
            label: that.$t ? that.$t(`message.departments`) : "Departmanlar",
            icon: {
                type: "material-icons",
                name: "domain",
            },
        },
        {
            get enabled() {
                return that && that.checkPermission("role.get");
            },
            key: "roles",
            group: that.$t ? that.$t(`message.company`) : "Company",
            label: that.$t ? that.$t(`message.roles`) : "Roller",
            icon: {
                type: "material-icons",
                name: "safety_divider",
            },
        },
        {
            get enabled() {
                return that.checkPermission("setting.get");
            },
            key: "audit-logs",
            group: that.$t ? that.$t(`message.company`) : "Company",
            label: that.$t ? that.$t(`settings.auditlogs`) : "Audit Logs",
            icon: {
                type: "material-icons",
                name: "storage",
            },
        },
        {
            get enabled() {
                return that && (that.isAdmin || that?.user?.role?.isRoot);
            },
            key: "access-control",
            group: that.$t ? that.$t(`message.company`) : "Company",
            label: that.$t ? that.$t(`settings.accessControl`) : "Access Control",
            icon: {
                type: "material-icons",
                name: "wifi_lock",
            },
        },
        {
            get enabled() {
                return that && (that.isAdmin || that?.user?.role?.isRoot);
            },
            key: "sessions",
            group: that.$t ? that.$t(`message.company`) : "Company",
            label: that.$t ? that.$t(`sessions.sessionManagement`) : "Session Management",
            icon: {
                type: "material-icons",
                name: "devices",
            },
        },
        {
            get enabled() {
                return that && that.checkPermission("welcome.get");
            },
            key: "system-messages",
            group: that.$t ? that.$t(`settings.chat`) : "Chat",
            label: that.$t ? that.$t(`message.welcomeMessages`) : "Welcome Messages",
            icon: {
                type: "material-icons",
                name: "waving_hand",
            },
        },

        {
            get enabled() {
                return that && that.checkPermission(["prepared.update", "prepared.delete", "prepared.create"]);
            },
            key: "templates",
            group: that.$t ? that.$t(`settings.chat`) : "Chat",
            label: that.$t ? that.$t(`plans.readyContents`) : "Templates",
            icon: {
                type: "material-icons",
                name: "bolt",
            },
        },

        {
            get enabled() {
                return that.checkPermission("setting.get");
            },
            key: "auto-assign",
            group: that.$t ? that.$t(`settings.chat`) : "Chat",
            label: that.$t ? that.$t(`settings.auto_assign`) : "Auto Assign",
            icon: {
                type: "material-icons",
                name: "settings_accessibility",
            },
        },
        {
            get enabled() {
                return that.checkPermission("setting.get");
            },
            key: "contact-module-rules",
            group: that.$t ? that.$t("settings.rulesGroup") : "Rules",
            label: that.$t ? that.$t("contactModuleRules.title") : "Contact Module Rules",
            icon: {
                type: "material-icons",
                name: "account_tree",
            },
        },
        {
            get enabled() {
                return that.checkPermission("setting.get");
            },
            key: "task-module-rules",
            group: that.$t ? that.$t("settings.rulesGroup") : "Rules",
            label: that.$t ? that.$t("taskModuleRules.title") : "Task Module Rules",
            icon: {
                type: "material-icons",
                name: "rule",
            },
        },
        {
            get enabled() {
                return that.checkPermission("setting.get");
            },
            key: "timings-settings",
            group: that.$t ? that.$t(`settings.chat`) : "Chat",
            label: that.$t ? that.$t(`settings.timing_settings`) : "Timings Settings",
            icon: {
                type: "material-icons",
                name: "hourglass_empty",
            },
        },
        {
            get enabled() {
                return that.checkPermission("setting.get");
            },
            key: "availability",
            group: that.$t ? that.$t(`settings.chat`) : "Chat",
            label: that.$t ? that.$t(`settings.availability`) : "Availability",
            icon: {
                type: "material-icons",
                name: "calendar_month",
            },
        },
        {
            get enabled() {
                return that && that.checkPermission("bannedWord.get");
            },
            key: "forbidden-inputs",
            group: that.$t ? that.$t(`settings.chat`) : "Chat",
            label: that.$t ? that.$t(`message.bannedWords`) : "Banned Words",
            icon: {
                type: "material-icons",
                name: "keyboard",
            },
        },
        // {
        //     get enabled() {
        //         return that.checkPermission("setting.get");
        //     },
        //     key: "website-integration",
        //     group: that.$t ? that.$t(`message.integrations`) : "Integration",
        //     label: that.$t ? that.$t(`settings.website-integration`) : "WebSite Integration",
        //     icon: {
        //         type: "material-icons",
        //         name: "integration_instructions",
        //     },
        // },
        {
            get enabled() {
                return that.checkPermission("setting.get");
            },
            key: "developer",
            group: that.$t ? that.$t(`message.integrations`) : "Integration",
            label: that.$t ? that.$t(`settings.developer`) : "Developer",
            icon: {
                type: "material-icons",
                name: "developer_mode",
            },
        },


    ];
};
export default SettingsMenuTypes;
